<app-core-popup
  [dialogStyle]="{ width: '55rem' }"
  [header]="'case.address-informations.patient-addresses' | translate"
  [saveText]="'common.save' | translate"
  (chooseOn)="save()"
  #corePopup
>
  <div class="table-responsive active-projects style-1">
    <p-table
      [value]="addresses"
      [(selection)]="selectedPatientAddress"
      selectionMode="single"
      [scrollable]="true"
      scrollHeight="30vh"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5%" scope="col"></th>

          <th style="width: 5%" scope="col">
            {{ "case.address-informations.patient-address-type" | translate }}
          </th>
          <th style="width: 5%" scope="col">
            {{
              "case.address-informations.patient-address-priority" | translate
            }}
          </th>
          <th style="width: 35%" scope="col">
            {{
              "case.address-informations.patient-address-formatted-address"
                | translate
            }}
          </th>
          <th style="width: 15%" scope="col">
            {{ "case.address-informations.patient-address-city" | translate }}
          </th>
          <th style="width: 15%" scope="col">
            {{
              "case.address-informations.patient-address-district" | translate
            }}
          </th>
          <th style="width: 10%" scope="col">
            {{
              "case.address-informations.patient-address-latitude" | translate
            }}
          </th>
          <th style="width: 10%" scope="col">
            {{
              "case.address-informations.patient-address-longitude" | translate
            }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-address>
        <tr [pSelectableRow]="address">
          <td>
            <p-tableRadioButton [value]="address" />
          </td>
          <td>{{ address?.title?.valueObject?.name?.value }}</td>
          <td>
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="address?.isPriority"
              disabled
            />
          </td>
          <td>{{ address?.formattedAddress }}</td>
          <td>{{ address?.city }}</td>
          <td>{{ address?.district }}</td>
          <td>{{ address?.latitude }}</td>
          <td>{{ address?.longitude }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</app-core-popup>
